import { render, staticRenderFns } from "./ProfilApprove.vue?vue&type=template&id=1aed7ed1"
import script from "./ProfilApprove.vue?vue&type=script&lang=js"
export * from "./ProfilApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports